module.exports = __webpack_public_path__ + "googlereviews.png?2988469379baf64f42c06fa158b5e989";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/googlereviews.png
// module id = 333
// module chunks = 0